import { createSelector } from 'reselect';
import { getPrescriptionGlasses, frameSkuProp, lensTypeSkuProp, packageSkuProp, addOnSkuProp } from '../selectors.internal.js';

const getProducts = createSelector(getPrescriptionGlasses, (pg)=>pg.products
);
const getFrames = createSelector(getProducts, (p)=>p.frames
);
const getLensTypes = createSelector(getProducts, (p)=>p.lensTypes
);
/**
 * Returns the SKUs of the lens-types that we've already loaded from the server
 */ createSelector(getLensTypes, (lensTypes)=>new Set(Object.keys(lensTypes))
);
const getPackages = createSelector(getProducts, (p)=>p.packages
);
createSelector(getPackages, (packages)=>new Set(Object.keys(packages))
);
const getFrame = createSelector(getFrames, frameSkuProp, (frames, frameSku)=>frames[frameSku]
);
const getLensType = createSelector(getLensTypes, lensTypeSkuProp, (lensTypes, lensTypeSku)=>lensTypes[lensTypeSku]
);
const getPackage = createSelector(getPackages, packageSkuProp, (packages, packageSku)=>packages[packageSku]
);
const getAddOns = createSelector(getProducts, (p)=>p.addOns
);
createSelector(getAddOns, (addOns)=>new Set(Object.keys(addOns))
);
const getAddOn = createSelector(getAddOns, addOnSkuProp, (addOns, addOnSku)=>addOns[addOnSku]
);
const getBundleProductVariants = createSelector(getProducts, (p)=>p.variants
);
/**
 * Whenever a lens type is not a master variant, we need to be able to find its parent lens type
 * to be able to use all of our state infrastructure and helpers in the same way as with a master variant.
 */ const lookupParentLensType = createSelector(getBundleProductVariants, getLensTypes, lensTypeSkuProp, (variants, lensTypes, lensTypeSku)=>{
    const masterSku = variants[lensTypeSku];
    if (!masterSku) {
        return undefined;
    }
    return lensTypes[masterSku];
});
/**
 * Whenever a lens add-on is not a master variant, we need to be able to find its parent add-on
 * to be able to use all of our state infrastructure and helpers in the same way as with a master variant.
 */ const lookupParentAddOn = createSelector(getBundleProductVariants, getAddOns, addOnSkuProp, (variants, addOns, addOnSku)=>{
    const masterSku = variants[addOnSku];
    if (!masterSku) {
        return undefined;
    }
    return addOns[masterSku];
});

export { getAddOn, getAddOns, getBundleProductVariants, getFrame, getFrames, getLensType, getLensTypes, getPackage, getPackages, getProducts, lookupParentAddOn, lookupParentLensType };
//# sourceMappingURL=selectors.internal.js.map
